import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber, IsEnum } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { OperationTypeEnum } from '@gtpl/shared-models/common-models';

export class OperationSequenceRequest {

    @ApiProperty()
    @IsOptional()
    plantId: number;

    @ApiProperty()
    @IsOptional()
    saleOrderItemId?: number;
    @ApiProperty({
         enum: Object.values(OperationTypeEnum) 
    })
    @IsEnum(OperationTypeEnum)
    presentOperation: OperationTypeEnum;

    constructor(plantId:number,presentOperation:OperationTypeEnum,saleOrderItemId?:number){
        this.plantId = plantId;
        this.saleOrderItemId = saleOrderItemId;
        this.presentOperation = presentOperation;

    }

   
}